<template>
  <div class="camera-update">
    <div class="title-update-menu">
      <div class="text update-title"> Камери</div>
    </div>
    <div class="name">
      <div class="label" >
        <label for="name" class="text title">Назва: </label> 
      </div>
      <input v-model="name" type="text" class="text" id="name">
    </div>
    <div class="geoaddr">
      <div class="label">
        <label for="geoaddr" class="text title">Розмiщення: </label> 
      </div>
      <input v-model="geoaddr" type="text" class="text" id="geoaddr">
    </div>
    <div class="info">
      <div class="label">
        <label for="info" class="text title">Додаткова iнформацiя: </label> 
      </div>
      <input v-model="info" type="text" class="text" id="info">
    </div>
    <div class="submits"> 
      <button class="cancel text" @click="cancel()">Вiдмiнити</button>
      <button class="save text" @click="submit()">Зберегти</button>
    </div>
  </div>
</template>

<script>

export default {
    
  name: "CameraUpdateMenuComponent",

  props: ['camera_update',],

  data () {
    return {
      name:'',
      geoaddr:'',
      info:'',
    }
  },

  created() {
    this.name = this.camera_update.camera.camera_info[0].name
    this.geoaddr = this.camera_update.camera.camera_info[0].geoaddr
    this.info = this.camera_update.camera.camera_info[0].info
  },

  methods: {
    
     submit () {
        this.$emit('submit_camera', {
          user_id:this.camera_update.camera.camera_info[0].user,
          name:this.name,
          geoaddr:this.geoaddr,
          info:this.info,
          camera_code:this.camera_update.camera.camera_code,
        })
      },

      cancel() {
        this.name = this.camera_update.camera.camera_info[0].name
        this.geoaddr = this.camera_update.camera.camera_info[0].geoaddr
        this.info = this.camera_update.camera.camera_info[0].info
      }

  }

}
</script>

<style scoped>


.label {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
}

.title-update-menu {
  width: 265px;
  height: 30px;
  margin-bottom: 17px;
  background: #383838;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}

.text {
  margin-bottom: 10px;
}

.update-title {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
}

#name, #geoaddr, #info {
  border: none;
  min-width: 265px;
  height: 28px;
  background: #848484;
  border-radius: 5px;

  font-style: normal;
  font-size: 14px;
}

.cancel {
width: 122px;
height: 31px;
background: #848484;
border-radius: 10px;
display: inline-block;
border: none;
cursor: pointer;
transition-duration: 0.4s;
text-align: center;
font-size: 14px;
line-height: 16px;
font-weight: bold;
margin-right: 5px;

}

.cancel:hover {
  background-color: #5e5e5e;
}

.save {
width: 122px;
height: 31px;
background: #83931B;
border-radius: 10px;
display: inline-block;
border: none;
cursor: pointer;
transition-duration: 0.4s;
text-align: center;
font-size: 14px;
line-height: 16px;
font-weight: bold;
}

.save:hover {
  background-color: #647014;
}




</style>